import React from 'react';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Moment from 'moment';

export default function FinanceSection(props) {
  const { ctx, res, profile, classes, link } = props;
  const readOnly = !ctx.state.editForm;

  const blockAndAlert = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (typeof ctx?.alertReadOnly === 'function') ctx.alertReadOnly();
  };

  const showActions = !!ctx.state.editForm;

  return (
    <div style={{ display: ctx.state.tabValue === 2 ? 'flex' : 'none', flexDirection: 'column', marginTop: '1rem' }}>
      <h2 style={{ margin: 0 }}>{res.FINANCEIRO}</h2>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', marginTop: '0.75rem' }}>
        <TextField
          label="Total de Hectares"
          value={ctx.calcFinanceTotalsFromJobs().totalHa.toLocaleString('pt-BR', { maximumFractionDigits: 2 })}
          InputProps={{ readOnly: true }}
          style={{ width: '14rem' }}
          margin="normal"
        />
        <TextField
          label="Total do Serviço"
          value={ctx.formatCurrency(ctx.calcFinanceTotalsFromJobs().totalNet)}
          InputProps={{ readOnly: true }}
          style={{ width: '16rem' }}
          margin="normal"
        />
        <TextField
          label="Descontos (Total)"
          value={ctx.formatCurrency(ctx.calcFinanceTotalsFromJobs().totalDiscount)}
          InputProps={{ readOnly: true }}
          style={{ width: '16rem' }}
          margin="normal"
        />
      </div>

      <Paper style={{ marginTop: '1rem', overflowX: 'auto' }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{res.CULTURA}</TableCell>
              <TableCell>{res.DATA}</TableCell>
              <TableCell>{res.AREA}</TableCell>
              <TableCell>{res.TIPO_SERVICO}</TableCell>
              <TableCell>{res.VALOR_HA}</TableCell>
              <TableCell>{res.FORMA_PAGAMENTO}</TableCell>
              <TableCell>{res.DATA_PREVISTA_PAGAMENTO}</TableCell>
              <TableCell>{res.DATA_PAGAMENTO}</TableCell>
              <TableCell>{res.DESCONTO}</TableCell>
              <TableCell>{res.VALOR_SERVICO}</TableCell>
              {showActions && <TableCell>{res.ACOES}</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {(ctx.state.jobsData || []).map((job, idx) => {
              const tipoServicoArr = [];
              if (job?.typeService?.insecticide) tipoServicoArr.push(res.INSETICIDA);
              if (job?.typeService?.herbicide) tipoServicoArr.push(res.HERBICIDA);
              if (job?.typeService?.fungicide) tipoServicoArr.push(res.FUNGICIDA);
              if (job?.typeService?.seeding) tipoServicoArr.push(res.SEMEADURA);
              if (job?.typeService?.fertilizing) tipoServicoArr.push(res.ADUBACAO);
              if (job?.typeService?.maturator) tipoServicoArr.push(res.MATURADOR);
              if (job?.typeService?.others && job?.servicoOutro) tipoServicoArr.push(job.servicoOutro);
              const tipoServico = tipoServicoArr.join(' / ') || '-';

              const fin = job.finance || {};
              const { area, valuePerHa, net } = ctx.computeJobFinance(job);

              let discountLabel = '-';
              if (fin.discountEnabled) {
                const parts = [];
                if (fin.discountValue) parts.push(ctx.formatCurrency(ctx.toNumber(fin.discountValue)));
                if (fin.discountPercent) parts.push(ctx.toNumber(fin.discountPercent).toLocaleString('pt-BR') + '%');
                discountLabel = parts.length ? parts.join(' / ') : '-';
              }

              return (
                <TableRow key={job.id || idx}>
                  <TableCell>{job.cultura || '-'}</TableCell>
                  <TableCell>{job.dateTimeTrabalho ? Moment(job.dateTimeTrabalho).format('DD/MM/YYYY') : ''}</TableCell>
                  <TableCell>{area.toLocaleString('pt-BR', { maximumFractionDigits: 2 })}</TableCell>
                  <TableCell>{tipoServico}</TableCell>
                  <TableCell>{ctx.formatCurrency(valuePerHa)}</TableCell>
                  <TableCell>{fin.paymentMethod || '-'}</TableCell>
                  <TableCell>{fin.dueDate ? Moment(fin.dueDate).format('DD/MM/YYYY') : '-'}</TableCell>
                  <TableCell>{fin.paymentDate ? Moment(fin.paymentDate).format('DD/MM/YYYY') : '-'}</TableCell>
                  <TableCell>{discountLabel}</TableCell>
                  <TableCell>{ctx.formatCurrency(net)}</TableCell>
                  {showActions && (
                    <TableCell>
                      <IconButton
                        onClick={() => { if (!readOnly) ctx.openFinanceEdit(idx); }}
                        onMouseDown={readOnly ? blockAndAlert : undefined}
                        onKeyDown={(e) => {
                          if (readOnly && (e.key === 'Enter' || e.key === ' ')) {
                            e.preventDefault();
                            e.stopPropagation();
                            blockAndAlert(e);
                          }
                        }}
                        tabIndex={readOnly ? -1 : 0}
                        aria-readonly={readOnly}
                        title={res.EDITAR}
                      >
                        <EditIcon />
                      </IconButton>
                    </TableCell>
                  )}
                </TableRow>
              );
            })}

            <TableRow>
              <TableCell colSpan={2} style={{ fontWeight: 700 }}>Total</TableCell>
              <TableCell style={{ fontWeight: 700 }}>
                {ctx.calcFinanceTotalsFromJobs().totalHa.toLocaleString('pt-BR', { maximumFractionDigits: 2 })}
              </TableCell>
              <TableCell />
              <TableCell />
              <TableCell />
              <TableCell />
              <TableCell style={{ fontWeight: 700 }}>
                {ctx.formatCurrency(ctx.calcFinanceTotalsFromJobs().totalDiscount)}
              </TableCell>
              <TableCell style={{ fontWeight: 700 }}>
                {ctx.formatCurrency(ctx.calcFinanceTotalsFromJobs().totalNet)}
              </TableCell>
              {showActions && <TableCell />}
            </TableRow>
          </TableBody>
        </Table>
      </Paper>

      {ctx.state.financeEditOpen && (() => {
        const idx = ctx.state.financeEditIndex;
        const job = ctx.state.jobsData[idx] || {};
        const fin = job.finance || {
          valuePerHa: '',
          paymentMethod: '',
          dueDate: '',
          confirmPayment: false,
          paymentDate: '',
          discountEnabled: false,
          discountValue: '',
          discountPercent: ''
        };
        const preview = ctx.computeJobFinance(job);

        return (
          <Paper elevation={2} style={{ marginTop: '1rem', background: '#fff' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.75rem 1rem', backgroundColor: '#2D3238' }}>
              <div />
              <h3 style={{ margin: 0, color: 'white', whiteSpace: 'nowrap' }}>{res.FINANCEIRO}</h3>
              <CloseIcon onClick={ctx.closeFinanceEdit} style={{ cursor: 'pointer', width: '2rem', height: '2rem', color: 'white' }} />
            </div>

            <div style={{ maxHeight: '70vh', overflowY: 'auto', background: 'white', padding: '1rem 2rem 1.5rem' }}>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
                <TextField
                  label={res.VALOR_HA}
                  type="number"
                  value={fin.valuePerHa || ''}
                  onChange={(e) => {
                    const value = e.target.value.toString().replace(',', '.');

                    if (value !== '' && !/^\d*\.?\d*$/.test(value)) {
                      return;
                    }

                    ctx.onFinanceJobChange('valuePerHa')({
                      target: {
                        value: value
                      }
                    });
                  }}
                  placeholder="Ex.: 80,00"
                  style={{ width: '14rem' }}
                  margin="normal"
                  inputProps={{ step: '0.01', min: '0' }}
                />
                <TextField
                  label={res.AREA}
                  value={preview.area.toLocaleString('pt-BR', { maximumFractionDigits: 2 })}
                  InputProps={{ readOnly: true }}
                  style={{ width: '12rem' }}
                  margin="normal"
                />
                <TextField
                  label={res.VALOR_TOTAL}
                  value={ctx.formatCurrency(preview.gross)}
                  InputProps={{ readOnly: true }}
                  style={{ width: '16rem' }}
                  margin="normal"
                />
              </div>

              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
                <TextField
                  label={res.FORMA_PAGAMENTO}
                  value={fin.paymentMethod || ''}
                  onChange={ctx.onFinanceJobChange('paymentMethod')}
                  style={{ width: '16rem' }}
                  margin="normal"
                />
                <TextField
                  label={res.DATA_PREVISTA_PAGAMENTO}
                  type="date"
                  value={fin.dueDate || ''}
                  onChange={ctx.onFinanceJobChange('dueDate')}
                  style={{ width: '14rem' }}
                  margin="normal"
                  InputLabelProps={{ shrink: true }}
                />
                <FormControlLabel
                  style={{ marginTop: '0.5rem' }}
                  control={
                    <Checkbox
                      checked={!!fin.confirmPayment}
                      onChange={ctx.toggleFinanceJob('confirmPayment')}
                      color="primary"
                    />
                  }
                  label={res.CONFIRMAR_PAGAMENTO}
                />
                <TextField
                  label={res.DATA_PAGAMENTO}
                  type="date"
                  value={fin.paymentDate || ''}
                  onChange={ctx.onFinanceJobChange('paymentDate')}
                  style={{ width: '14rem' }}
                  margin="normal"
                  InputLabelProps={{ shrink: true }}
                  disabled={!fin.confirmPayment}
                />
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginTop: '0.5rem' }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!fin.discountEnabled}
                      onChange={ctx.toggleFinanceJob('discountEnabled')}
                      color="primary"
                    />
                  }
                  label={res.APLICA_DESCONTO}
                />
                <TextField
                  label={res.VALOR_DESCONTO}
                  type="number"
                  value={fin.discountValue || ''}
                  onChange={(e) => {
                    const value = e.target.value.toString().replace(',', '.');

                    if (value !== '' && !/^\d*\.?\d*$/.test(value)) {
                      return;
                    }

                    ctx.onDiscountValueJobChange({
                      target: {
                        value: value
                      }
                    });
                  }}
                  placeholder="Ex.: 500,00"
                  style={{ width: '12rem' }}
                  margin="dense"
                  disabled={!fin.discountEnabled}
                  inputProps={{ step: '0.01', min: '0' }}
                />
                <TextField
                  label={res.PERCENTUAL_DESCONTO}
                  type="number"
                  value={fin.discountPercent || ''}
                  onChange={(e) => {
                    const value = e.target.value.toString().replace(',', '.');

                    if (value !== '' && !/^\d*\.?\d*$/.test(value)) {
                      return;
                    }

                    ctx.onDiscountPercentJobChange({
                      target: {
                        value: value
                      }
                    });
                  }}
                  placeholder="Ex.: 10"
                  style={{ width: '8rem', whiteSpace: 'nowrap' }}
                  margin="dense"
                  disabled={!fin.discountEnabled}
                  inputProps={{ step: '0.01', min: '0', max: '100' }}
                />
                <TextField
                  label={res.VALOR_TOTAL_DESCONTO}
                  value={ctx.formatCurrency(ctx.computeJobFinance(ctx.state.jobsData[idx]).net)}
                  InputProps={{ readOnly: true }}
                  style={{ width: '16rem' }}
                  margin="dense"
                />
              </div>

              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', marginTop: '1rem' }}>
                <Button onClick={ctx.closeFinanceEdit} color="secondary" variant="outlined">{res.CANCELAR}</Button>
                <Button onClick={() => ctx.saveFinanceJob(false)} color="primary" variant="contained">{res.SALVAR}</Button>
                <Button onClick={() => ctx.saveFinanceJob(true)} color="primary" variant="contained">{res.SALVAR_APLICAR_TODOS}</Button>
              </div>
            </div>
          </Paper>
        );
      })()}
    </div>
  );
}